import React from 'react';
import { Link } from 'react-router-dom';

export default function ToggleableLink(props)  {
    const { disabled, ...rest } = props;
    return disabled ? <a href="#" className="btn btn-default btn-sm disabled" disabled="true">{props.children}</a>  : <Link {...rest}></Link>;
}